<template>
    <div class="news-item">
        <router-link class="news-item__back h1 link-not-like" to="/news">
            <svg
                width="9"
                height="15"
                viewBox="0 0 9 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7.72461 13.7069L1.51771 7.50001L7.72461 1.29312"
                    stroke="#2C1521"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>

            {{ $vuetify.lang.t("$vuetify.news") }}
        </router-link>

        <div class="news-item__grid">
            <div class="cards__single">
                <div class="news-item__preview">
                    <img :src="$media_url + currentNew.photo_path" alt="" />
                </div>

                <div class="news-item__content">
                    <h2>{{ currentNew.title }}</h2>
                    <div class="view-mode-table" v-html="currentNew.text"></div>
                </div>

                <div class="news-item__footer">
                    <div
                        v-if="
                            permissions.admin &&
                            currentNew.organization == organization_id
                        "
                        class="news-item__buttons btn-action__group"
                    >
                        <router-link
                            class="btn-icon btn-action"
                            :to="'/newsEdit/' + id"
                        >
                            <picture>
                                <edit-icon />
                            </picture>
                        </router-link>
                        <button
                            class="btn-icon btn-action"
                            @click="confirm_modal = true"
                        >
                            <picture>
                                <delete-icon />
                            </picture>
                        </button>
                        <button
                            class="btn-icon btn-action"
                            @click="confirm_archive_modal = true"
                        >
                            <picture>
                                <archive-icon />
                            </picture>
                        </button>
                    </div>

                    <div class="news-item__info">
                        <span> {{ currentNew.date }} </span>
                        <svg
                            width="2"
                            height="2"
                            viewBox="0 0 2 2"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="1" cy="1" r="1" fill="#ADB2B7" />
                        </svg>
                        <!--<span> Алексей Горбатовский </span>-->
                    </div>

                    <div class="">
                        <h3 class="mb-3">
                            {{ $vuetify.lang.t("$vuetify.comments") }}
                        </h3>
                        <CommentList
                            table="news"
                            :id="id"
                            :showNothing="false"
                        />
                    </div>
                </div>
            </div>
            <div class="news-item__others">
                <div class="h2">
                    {{ $vuetify.lang.t("$vuetify.readAlso") }}
                </div>
                <div class="news-item__list">
                    <news-card
                        v-for="item in otherNews"
                        :key="item.id"
                        :id="item.id"
                        :image="$media_url + item.photo_path"
                        :title="item.title"
                        :author="
                            item.author
                                ? item.author.name + ' ' + item.author.lastname
                                : ''
                        "
                        :date="item.create_date"
                    ></news-card>
                </div>
            </div>
        </div>
        <ConfirmModal v-model="confirm_modal" @confirm="deleteNew">
            <span v-if="alertError">{{ alertMsg }}</span>
        </ConfirmModal>
        <ConfirmArchiveModal
            v-model="confirm_archive_modal"
            @confirm="archiveNew"
            :active="true"
        >
            <span v-if="alertError">{{ alertMsg }}</span>
        </ConfirmArchiveModal>
    </div>
</template>

<script>
import ConfirmModal from "@/components/confirmModal.vue";
import EditIcon from "@/components/icons/EditIcon";
import DeleteIcon from "@/components/icons/DeleteIcon";
import NewsCard from "@/views/parts/NewsCard";
import ConfirmArchiveModal from "@/components/ConfirmArchiveModal";
import ArchiveIcon from "@/components/icons/ArchiveIcon";
import { mapGetters } from "vuex";
import CommentList from "@/components/icons/CommentList.vue";

export default {
    name: "news-item",
    components: {
        CommentList,
        ArchiveIcon,
        ConfirmArchiveModal,
        NewsCard,
        DeleteIcon,
        EditIcon,
        ConfirmModal,
    },
    props: {
        id: String,
    },

    mounted() {
        this.loadData();
        this.loadOtherNews();

        // Add global event listener to prevent editing
        document.addEventListener("DOMNodeInserted", this.disableTableEditing);
    },

    updated() {
        this.$nextTick(() => {
            this.disableTableEditing();
        });
    },

    beforeDestroy() {
        // Remove event listener when component is destroyed
        document.removeEventListener(
            "DOMNodeInserted",
            this.disableTableEditing
        );
    },

    data: function () {
        return {
            organization_id: JSON.parse(localStorage.getItem("organization"))
                .id,
            currentNew: {},
            confirm_modal: false,
            confirm_archive_modal: false,

            otherNews: [],

            alertError: false,
            alertMsg: "",
        };
    },

    methods: {
        disableTableEditing() {
            // Find all editable elements in the view-mode-table
            const viewModeTable = document.querySelector(".view-mode-table");
            if (!viewModeTable) return;

            // Disable contentEditable on the container itself
            viewModeTable.setAttribute("contenteditable", "false");
            viewModeTable.contentEditable = false;

            // Prevent default behavior for any possible edit events
            viewModeTable.addEventListener(
                "beforeinput",
                (e) => e.preventDefault(),
                true
            );
            viewModeTable.addEventListener(
                "input",
                (e) => e.preventDefault(),
                true
            );

            // Find all contentEditable elements
            const editableElements = viewModeTable.querySelectorAll(
                '[contenteditable="true"], [contenteditable=true]'
            );
            editableElements.forEach((el) => {
                el.setAttribute("contenteditable", "false");
                el.contentEditable = false;
                // Remove all event listeners
                const newEl = el.cloneNode(true);
                if (el.parentNode) {
                    el.parentNode.replaceChild(newEl, el);
                }
            });

            // Specifically target table cells
            const tableCells = viewModeTable.querySelectorAll("td, th");
            tableCells.forEach((cell) => {
                cell.setAttribute("contenteditable", "false");
                cell.contentEditable = false;

                // Prevent editing via events
                cell.addEventListener(
                    "click",
                    (e) => e.stopPropagation(),
                    true
                );
                cell.addEventListener(
                    "beforeinput",
                    (e) => e.preventDefault(),
                    true
                );
                cell.addEventListener("input", (e) => e.preventDefault(), true);
            });

            // Disable any table buttons completely
            const tableButtons = viewModeTable.querySelectorAll(
                "button, .row-btn, .col-btn, .table-delete-btn"
            );
            tableButtons.forEach((btn) => {
                btn.disabled = true;
                btn.style.pointerEvents = "none";
            });
        },

        loadData() {
            this.$axios({
                url: this.$hostname + "time-tracking/news/" + this.id,
                method: "GET",
                headers: {
                    Authorization:
                        "Token " +
                        (localStorage.getItem("auth_token") ||
                            sessionStorage.getItem("auth_token")),
                },
            }).then((response) => {
                this.currentNew = response.data.data.data[0];
            });
        },
        loadOtherNews() {
            this.$axios({
                url: this.$hostname + "time-tracking/news",
                method: "GET",
                params: {
                    except: this.id,
                    limit: 3,
                    arch: true,
                },
            }).then((response) => {
                this.otherNews = response.data.data.data;
            });
        },

        archiveNew() {
            this.$axios({
                url: this.$hostname + "time-tracking/news",
                method: "PUT",
                headers: {
                    Authorization:
                        "Token " +
                        (localStorage.getItem("auth_token") ||
                            sessionStorage.getItem("auth_token")),
                    "Content-Type": "multipart/form-data",
                },
                data: {
                    id: this.currentNew.id,
                    title: this.currentNew.title,
                    text: this.currentNew.text,
                    active: !this.currentNew.active,
                },
            })
                .then(() => {
                    this.confirm_archive_modal = false;
                })
                .catch((errors) => {
                    this.alertError = true;
                    this.alertMsg = this.$catch(errors);
                });
        },
        deleteNew() {
            this.$axios({
                url: this.$hostname + "time-tracking/news",
                method: "DELETE",
                headers: {
                    Authorization:
                        "Token " +
                        (localStorage.getItem("auth_token") ||
                            sessionStorage.getItem("auth_token")),
                    "Content-Type": "multipart/form-data",
                },
                data: {
                    id: this.id,
                },
            }).then(() => {
                this.$router.push("/news");
            });
        },
    },
    computed: {
        ...mapGetters(["permissions"]),
    },
};
</script>
